<on-page-title
    icon="fa-clone"
    title="{{ 'company.duplicates.title' | translate }}"
    [showReloadButton]="true"
    (reload)="reload()"
></on-page-title>

<on-loading *ngIf="isLoading"></on-loading>

<div class="col" *ngIf="!isLoading">
    <div class="mb-3">
        <p class="info-text">
            {{ 'company.duplicates.description' | translate }}
        </p>
    </div>

    <!-- Status filter -->
    <div class="row mb-3">
        <div class="col-md-3">
            <select
                class="form-select form-select-sm"
                [(ngModel)]="selectedStatus"
                (change)="onStatusFilterChange()"
            >
                <option value="">
                    {{ 'company.duplicates.all-statuses' | translate }}
                </option>
                <option value="Pending">
                    {{ 'company.duplicates.status-pending' | translate }}
                </option>
                <option value="Confirmed">
                    {{ 'company.duplicates.status-confirmed' | translate }}
                </option>
                <option value="Dismissed">
                    {{ 'company.duplicates.status-dismissed' | translate }}
                </option>
            </select>
        </div>
    </div>

    <!-- Empty state -->
    <on-empty-list
        *ngIf="reportGroups.length === 0"
        [message]="'company.duplicates.no-suspicions' | translate"
    ></on-empty-list>

    <!-- Grouped by report in accordion -->
    <nb-accordion multi *ngIf="reportGroups.length > 0">
        <nb-accordion-item
            *ngFor="let group of reportGroups"
            [collapsed]="true"
        >
            <nb-accordion-item-header>
                <div class="d-flex align-items-center">
                    <strong class="me-2">{{ group.reportName }}</strong>
                    <span class="me-2" *ngIf="group.userDisplayName">
                        - {{ group.userDisplayName }}
                        (<em>{{ group.userEmail }}</em>)
                    </span>
                    <span class="me-2" *ngIf="!group.userDisplayName">
                        - <em>{{ group.userEmail }}</em>
                    </span>
                    <span
                        class="badge bg-warning text-dark me-1"
                        *ngIf="getPendingCount(group) > 0"
                    >
                        {{ getPendingCount(group) }} {{
                            'company.duplicates.pending-review' | translate
                        }}
                    </span>
                    <span
                        class="badge bg-danger me-1"
                        *ngIf="hasConfirmed(group)"
                    >
                        {{
                            'company.duplicates.has-confirmed-duplicates'
                                | translate
                        }}
                    </span>
                </div>
            </nb-accordion-item-header>
            <nb-accordion-item-body>
                <!-- Suspicions table -->
                <table class="table align-middle mb-0 suspicion-table">
                    <thead class="table-light">
                        <tr>
                            <th>{{ 'company.duplicates.status-header' | translate }}</th>
                            <th>{{ 'company.duplicates.this-receipt' | translate }}</th>
                            <th>{{ 'company.duplicates.matched-with' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="let suspicion of group.suspicions"
                            class="suspicion-row"
                            (click)="openCompare(suspicion)"
                        >
                            <!-- Status + confidence -->
                            <td style="width: 160px">
                                <span
                                    class="badge"
                                    [ngClass]="getStatusBadgeClass(suspicion.Status)"
                                >
                                    {{
                                        'company.duplicates.status-' +
                                            suspicion.Status.toLowerCase()
                                            | translate
                                    }}
                                </span>
                                <div class="confidence-indicator mt-1" *ngIf="suspicion.Status === 'Pending'">
                                    <div class="confidence-bar">
                                        <div
                                            class="confidence-fill"
                                            [style.width]="getConfidencePercent(suspicion.Confidence)"
                                            [ngClass]="getConfidenceBarClass(suspicion.Confidence)"
                                        ></div>
                                    </div>
                                    <small class="text-muted">
                                        {{ getConfidencePercent(suspicion.Confidence) }}
                                    </small>
                                </div>
                            </td>

                            <!-- This receipt (expense A) -->
                            <td>
                                <strong>{{ suspicion.Expense?.Emitter || '-' }}</strong><br />
                                <small class="text-muted">
                                    {{ suspicion.Expense?.DateOnExpense | date : 'dd/MM/yyyy' }}
                                    &middot;
                                    {{ suspicion.Expense?.TotalTtc | number : '1.2-2' }}
                                    {{ suspicion.Expense?.CurrencySymbol || suspicion.Expense?.CurrencyCode || '€' }}
                                </small>
                                <br *ngIf="suspicion.Expense?.Comments" />
                                <small class="text-info fst-italic" *ngIf="suspicion.Expense?.Comments">
                                    <nb-icon icon="fa-comment"></nb-icon>
                                    {{ suspicion.Expense.Comments }}
                                </small>
                            </td>

                            <!-- Matched receipt (expense B) -->
                            <td>
                                <strong>{{ suspicion.SuspectedDuplicate?.Emitter || '-' }}</strong><br />
                                <small class="text-muted">
                                    {{ suspicion.SuspectedDuplicate?.DateOnExpense | date : 'dd/MM/yyyy' }}
                                    &middot;
                                    {{ suspicion.SuspectedDuplicate?.TotalTtc | number : '1.2-2' }}
                                    {{ suspicion.SuspectedDuplicate?.CurrencySymbol || suspicion.SuspectedDuplicate?.CurrencyCode || '€' }}
                                    &middot;
                                    {{ suspicion.SuspectedDuplicate?.ReportName }}
                                    ({{ suspicion.SuspectedDuplicate?.UserName }})
                                </small>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- Report footer actions -->
                <div
                    class="p-2 bg-danger bg-opacity-10 d-flex justify-content-between align-items-center"
                    *ngIf="allReviewed(group) && hasConfirmed(group) && !isReportAlreadyRefused(group)"
                >
                    <span class="text-danger">
                        <nb-icon icon="fa-exclamation-triangle"></nb-icon>
                        {{ 'company.duplicates.duplicate-confirmed-hint' | translate }}
                    </span>
                    <button class="btn btn-sm btn-danger" (click)="sendBackReport(group)">
                        <nb-icon icon="fa-undo"></nb-icon>
                        {{ 'company.duplicates.send-back-report' | translate }}
                    </button>
                </div>
                <div
                    class="p-2 bg-secondary bg-opacity-10"
                    *ngIf="isReportAlreadyRefused(group)"
                >
                    <span class="text-muted">
                        <nb-icon icon="fa-check-circle"></nb-icon>
                        {{ 'company.duplicates.report-already-sent-back' | translate }}
                    </span>
                </div>
                <div
                    class="p-2 bg-light"
                    *ngIf="!allReviewed(group) && !isReportAlreadyRefused(group)"
                >
                    <small class="text-muted">
                        <nb-icon icon="fa-hourglass-half"></nb-icon>
                        {{ 'company.duplicates.review-all-before-action' | translate }}
                    </small>
                </div>
            </nb-accordion-item-body>
        </nb-accordion-item>
    </nb-accordion>
</div>

<!-- Compare modal template -->
<ng-template #compareModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">
            {{ 'company.duplicates.compare-title' | translate }}
        </h5>
        <button
            type="button"
            class="btn-close"
            (click)="modal.dismiss()"
            aria-label="Close"
        ></button>
    </div>
    <div class="modal-body">
        <div class="row" *ngIf="compareExpenseA && compareExpenseB">
            <div class="col-6 text-center compare-panel">
                <h6>
                    {{ 'company.duplicates.this-receipt' | translate }}
                    <small class="text-muted">- {{ compareExpenseA.Emitter || '' }}</small>
                </h6>
                <ngx-image-viewer
                    *ngIf="compareExpenseA.ImageUrl"
                    [src]="[compareExpenseA.ImageUrl]"
                    [config]="imageConfig"
                ></ngx-image-viewer>
                <p class="text-muted mt-3" *ngIf="!compareExpenseA.ImageUrl">
                    {{ 'company.duplicates.no-image' | translate }}
                </p>
            </div>
            <div class="col-6 text-center compare-panel">
                <h6>
                    {{ 'company.duplicates.matched-with' | translate }}
                    <small class="text-muted">- {{ compareExpenseB.Emitter || '' }}</small>
                </h6>
                <ngx-image-viewer
                    *ngIf="compareExpenseB.ImageUrl"
                    [src]="[compareExpenseB.ImageUrl]"
                    [config]="imageConfig"
                ></ngx-image-viewer>
                <p class="text-muted mt-3" *ngIf="!compareExpenseB.ImageUrl">
                    {{ 'company.duplicates.no-image' | translate }}
                </p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <span class="me-auto" *ngIf="compareSuspicion?.Status !== 'Pending'">
            <span
                class="badge"
                [ngClass]="getStatusBadgeClass(compareSuspicion.Status)"
            >
                {{ 'company.duplicates.status-' + compareSuspicion.Status.toLowerCase() | translate }}
            </span>
        </span>
        <button
            class="btn btn-outline-danger"
            [class.active]="compareSuspicion?.Status === 'Confirmed'"
            (click)="confirmFromModal()"
            [disabled]="compareSuspicion?.Status === 'Confirmed'"
        >
            <nb-icon icon="fa-check"></nb-icon>
            {{ 'company.duplicates.confirm-duplicate' | translate }}
        </button>
        <button
            class="btn btn-outline-success"
            [class.active]="compareSuspicion?.Status === 'Dismissed'"
            (click)="dismissFromModal()"
            [disabled]="compareSuspicion?.Status === 'Dismissed'"
        >
            <nb-icon icon="fa-times"></nb-icon>
            {{ 'company.duplicates.dismiss-duplicate' | translate }}
        </button>
    </div>
</ng-template>
